jQuery( document ).ready(function() {

    function typeInline(el, {
        startDelay = 0,
        charDelay = 20
    } = {}) {

        const nodes = Array.from(el.childNodes);
        el.innerHTML = "";
        el.classList.add("is-visible");

        let nodeIndex = 0;

        function processNode() {
            if (nodeIndex >= nodes.length) {
                // ✅ LINE FINISHED → play any video inside
                const video = el.querySelector("video");
                if (video) {
                    video.play().catch(() => {});
                }
                return;
            }

            const node = nodes[nodeIndex];

            // TEXT NODE → type characters
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent.replace(/\s+/g, " ");
                let i = 0;

                const span = document.createElement("span");
                span.className = "type-cursor";
                el.appendChild(span);

                const interval = setInterval(() => {
                    span.textContent += text[i] || "";
                    i++;

                    if (i >= text.length) {
                        clearInterval(interval);
                        span.classList.remove("type-cursor");
                        nodeIndex++;
                        processNode();
                    }
                }, charDelay);
            }

            // ELEMENT NODE → append instantly
            else {
                el.appendChild(node);
                nodeIndex++;
                processNode();
            }
        }

        setTimeout(processNode, startDelay);
    }
    function isInViewport(el, offset = 0) {
        const container = document.querySelector(".am-about-area");

        // measure final height
        const finalHeight = container.scrollHeight;

        // lock height BEFORE animation
        container.style.minHeight = finalHeight + "px";
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;

        return rect.top <= vh - offset;
    }

    const container = document.getElementById("aboutTyping");

    let started = false;

    function onScroll() {
        if (started || container === null) return;
        const lines = container.querySelectorAll(".type-line");
        if (isInViewport(container, 150)) {
            started = true;
            window.removeEventListener("scroll", onScroll);

            lines.forEach((line, i) => {
                typeInline(line, {
                    startDelay: i * 700,
                    charDelay: 20
                });
            });
        }
    }

// run once in case already visible
    window.addEventListener("scroll", onScroll);
    onScroll();
});